import { DateRangeSchema } from 'common/hooks/customSearchParams';
import moment, { Moment } from 'moment';

/** Test if a DateRangeSchema refers to yesterday */
export const isYesterday = (range: DateRangeSchema) => {
  return range.exactDate === '-1:days' || range.startDate === '-1:days';
};

/** Test if a DateRangeSchema refers to today */
export const isToday = (range: DateRangeSchema) => {
  return range.exactDate === 'today' || range.endDate === 'today';
};

/** Test if a DateRangeSchema refers to more than five days in the past */
export const isMoreThanFive = (range: DateRangeSchema) => {
  return range.endDate === '-5:days';
};

/** Test if a DateRangeSchema refers to less than five days in the past */
export const isLessThanFive = (range: DateRangeSchema) => {
  return range.startDate === '-5:days';
};

/** Test and parse if a DateRangeSchema is just a simple date range */
export const parseDateRange = (range: DateRangeSchema) => {
  let startDate: Moment | null = moment(range.startDate);
  let endDate: Moment | null = moment(range.endDate);

  startDate = (startDate.isValid() && startDate) || null;
  endDate = (endDate.isValid() && endDate) || null;

  if (startDate?.isValid() || endDate?.isValid()) {
    return { startDate, endDate };
  }

  return null;
};
